<template>
  <div
    id="userprofiledia"
    class="container border border-2 mt-5  p-3 mb-5  rounded"
    style="rounded-0;"
    @blur="onblur"
    @mouseenter="onmouseenter"
    @mouseleave="onmouseout"
    tabindex="500"
  >
    <el-row justify="start" class="mx-3">
      <h1 class="h5 fw-normal">{{ username }}</h1>
    </el-row>
    <el-row justify="start" class="mx-3">
      <h5 class="h5 sfont">{{ email }}</h5>
    </el-row>
    <el-row justify="start" class="mx-3">
      <h5 class="h5 mb-2 fw-normal">{{$t('userprofilemessage.function')}}</h5>
    </el-row>
    <el-row>
      <el-col :span="2"></el-col>
      <el-col :span="2"><i class="bi bi-download" :title="$t('userprofilemessage.download')"></i></el-col>
      <el-col :span="2"><i class="bi bi-search" :title="$t('userprofilemessage.search')"></i></el-col>
    </el-row>

    <el-divider></el-divider>
    <button
      type="button"
      class="col-md-12 mb-4 btn-rounded"
      @click="oneditprofile"
    >
      {{edit}}
      
    </button>
    <button
      type="button"
      class="col-md-12 mb-4 btn-rounded"
      @click="onloginout"
    >
      {{logout}}
    </button>
  </div>
</template>

<script>
import { logout, getuserprofile } from "../../js/userhandler";
import { reactive, onMounted, toRefs } from "vue";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import {useI18n} from 'vue-i18n'
export default {
  setup(props, { emit }) {

    const {t}=useI18n()
    const state = reactive({
      username: "test",
      email: "test",
      mouseout: true,
      edit:t('userprofilemessage.edit'),
      logout:t('userprofilemessage.logout'),
    });
    const router=useRouter();
    

    onMounted(() => {
      document.getElementById("userprofiledia").focus();
      getuserprofile().then((res) => {
        if (res.status === 200) {
          if (res.data.status == "1") {
            state.username = res.data.username;
            state.email = res.data.email;
          } else {
            //session过期
            emit("userlogout");
            onblur();
          }
        }
      });
    });

    function onblur() {
      if (state.mouseout) emit("userprofileblur", "");
    }

    //用户点击编辑用户信息按钮
    function oneditprofile()
    {
        emit("userprofileblur", ""); //关闭窗口
        router.push('userprofile')
    }
    //用户点击退出按钮
    function onloginout() {
      logout().then((res) => {
        if (res.status == "200") {
          ElMessage.success({ message: t('loginmessage.logoutsuccess') });
          emit("userlogout"); //退出登录消息通知
          emit("userprofileblur", ""); //关闭窗口
        } else {
          ElMessage.error({ message: "SERVE ERROR!" });
        }
      });
    }
    function onmouseout() {
      state.mouseout = true;
    }
    function onmouseenter() {
      document.getElementById("userprofiledia").focus();
      state.mouseout = false;
    }
    return { ...toRefs(state), onblur, onloginout, onmouseout, onmouseenter,oneditprofile };
  },
};
</script>

<style scoped>
.sfont {
  color: rgb(17, 92, 231);
  font-size: 0.7em;
}
#userprofiledia{
  box-shadow: 0px 2px 12px 1px rgba(0, 0, 0, 0.7);
}
</style>
